import { Link } from '@warp-ds/components/react/link';
import { Expandable } from '@warp-ds/react';

type LinkItem = {
    label: string;
    href: string;
};

export type DestinationItem = {
    title: string;
    links: LinkItem[];
};

export const ExpandableDestinationList = ({ title, links }: DestinationItem) => (
    <div className="border-b s-border">
        <Expandable title={<span className="text-16 font-bold">{title}</span>} animated buttonClass="w-full justify-between p-16">
            <ul className="mb-16">
                {links.map((link) => (
                    <li key={link.href} className="px-16 py-8">
                        <Link href={link.href} className="block underline s-text">
                            {link.label}
                        </Link>
                    </li>
                ))}
            </ul>
        </Expandable>
    </div>
);
